export const GUEST_EMAIL = 'guest@swissmarketplace.group';
